<div appDialogSelectable appDialogKeyboardEnabled>
  <div
    class="atlas-context-inputs-dialog"
    (cdkDragStarted)="dialogBoundryService.handleDragStart($event)"
    (cdkDragEnded)="dialogBoundryService.handleDragEnd($event)"
    cdkDragRootElement=".cdk-overlay-pane"
    cdkDrag
  >
    <div appDialogDragArea cdkDragHandle></div>
    <div class="modal-content">
      <div class="modal-header">
        <div class="modal-header-title">Case Context Fields · {{ data?.caseNumber || '-' }}</div>
        <div class="modal-buttons">
          <div (click)="close()">
            <img src="/assets/icons/Close White.svg" alt="Close" />
          </div>
        </div>
      </div>

      <div class="modal-content-body context-inputs-dialog">
        <div class="modal-body">
          <div class="context-toolbar">
            <div class="context-toolbar-copy">
              Choose which available case fields Atlas can use.
            </div>
            <div class="context-toolbar-actions">
              <button class="context-bulk-button context-bulk-button-enable" type="button" (click)="enableAllAvailableFields()">
                Enable all
              </button>
              <button class="context-bulk-button context-bulk-button-disable" type="button" (click)="disableAllAvailableFields()">
                Disable all
              </button>
            </div>
          </div>

          <div class="context-shell">
            <div *ngFor="let field of contextFields; trackBy: trackByContextField" class="context-row">
              <div class="context-left">
                <div class="context-name-row">
                  <div class="context-name">{{ field.label }}</div>
                  <span class="context-source-badge" [ngClass]="field.sourceClass">{{ field.sourceLabel }}</span>
                </div>
                <div class="context-value">{{ values[field.key] || '-' }}</div>
              </div>
              <button
                class="context-toggle"
                type="button"
                role="switch"
                [disabled]="isFieldToggleDisabled(field.key)"
                [attr.aria-checked]="settings[field.key]"
                [class.context-toggle-disabled]="isFieldToggleDisabled(field.key)"
                [class.context-toggle-on]="settings[field.key]"
                (click)="toggleSetting(field.key)"
              >
                <span class="context-toggle-thumb"></span>
              </button>
            </div>
          </div>

          <div class="dialog-actions">
            <button class="action-button cancel" type="button" (click)="close()">Close</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
